class PasswordResetModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)
    this.listeners.add(this.els.close.element, 'click', this.handleClose)
  }

  async handleClose (event) {
    event.preventDefault()

    this.classList.remove('prm-PasswordReset-active')
  }
}

if (!customElements.get('password-reset-modal')) {
  customElements.define('password-reset-modal', PasswordResetModal)
}
